import { ArrowLeft2, ArrowRight2 } from "iconsax-react";

function Pagination(props) {
  const { state, pageOptions, gotoPage, nextPage, previousPage, pageChangeHandler = null, totalData = null, currentPage = null } = props;
  const isExternalPagination = pageChangeHandler && totalData !== null;
  const activePage = isExternalPagination && currentPage !== null ? currentPage : state.pageIndex;
  const totalPages = isExternalPagination ? totalData : pageOptions.length;
  const pages = isExternalPagination ? Array.from({ length: totalData }, (_, i) => i) : pageOptions;

  const maxButton = 5;

  const onNext = () => {
    if (isExternalPagination) {
      if (activePage < totalPages - 1) {
        pageChangeHandler(activePage + 1);
      }
    } else {
      nextPage();
    }
  };

  const onPrevious = () => {
    if (isExternalPagination) {
      if (activePage > 0) {
        pageChangeHandler(activePage - 1);
      }
    } else {
      previousPage();
    }
  };

  const handlePageClick = (page) => {
    if (isExternalPagination) {
      pageChangeHandler(page);
    } else {
      gotoPage(page);
    }
  };

  return (
    <>
      <nav className="my-3 px-4 flex  flex-col items-center justify-between sm:px-0">
        <div className="hidden md:-mt-px md:flex">
          <button
            className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
            onClick={() => onPrevious()}
            disabled={activePage === 0}
          >
            <ArrowLeft2 className="h-5 w-5" aria-hidden="true" />
          </button>
          {pages.map((page) => {
            if (activePage === page) {
              return (
                <button
                  key={page}
                  onClick={() => handlePageClick(page)}
                  className="z-10 bg-indigo-50 border-indigo-500 text-indigo-600 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                >
                  {page + 1}
                </button>
              );
            }
            if (pages.length <= maxButton) {
              return (
                <button
                  key={page}
                  onClick={() => handlePageClick(page)}
                  className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                >
                  {page + 1}
                </button>
              );
            } else if (
              (activePage <= 2 && page < 5) ||
              (activePage >= pages.length - 2 &&
                page >= pages.length - 5)
            ) {
              return (
                <button
                  key={page}
                  onClick={() => handlePageClick(page)}
                  className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                >
                  {page + 1}
                </button>
              );
            } else if (activePage + 2 >= page && activePage - 2 <= page) {
              return (
                <button
                  key={page}
                  onClick={() => handlePageClick(page)}
                  className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                >
                  {page + 1}
                </button>
              );
            }
          })}
          <button
            className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
            onClick={() => onNext()}
            disabled={activePage >= totalPages - 1}
          >
            <ArrowRight2 className="h-5 w-5" aria-hidden="true" />
          </button>
        </div>
      </nav>
    </>
  );
}

export default Pagination;